import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1543.86059,983 C1642.5128,983 1733.91319,1043.3435 1771.13012,1133.243 C1807.93656,1222.18467 1783.71819,1321.6625 1706.27415,1399.11017 C1615.96838,1489.42017 1493.23463,1600.11833 1417.84299,1667.16667 L1417.84299,1667.16667 L1783.30771,1667.16667 L1783.30771,1804 L1304.41346,1804 C1266.64923,1804 1236,1773.34933 1236,1735.58333 L1236,1735.58333 L1236,1675.65033 C1236,1655.94633 1244.6201,1637.06333 1259.53423,1624.06417 C1261.72346,1622.1485 1475.99443,1435.91833 1609.53751,1302.369 C1648.12271,1263.782 1660.3003,1223.41617 1644.70204,1185.51333 C1628.69328,1146.7895 1587.23473,1119.83333 1543.86059,1119.83333 C1443.70328,1119.83333 1359.9652,1228.34217 1359.00741,1229.57367 L1359.00741,1229.57367 L1249.68269,1147.2 C1254.74529,1140.49517 1374.87933,983 1543.86059,983 Z M1373,162 L1373,298.8 L825.888889,298.8 L825.888889,1530 L689.111111,1530 L689.111111,298.8 L142,298.8 L142,162 L1373,162 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextSubscriptLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextSubscriptLine, _Component);

  var _super = _createSuper(IconTextSubscriptLine);

  function IconTextSubscriptLine() {
    _classCallCheck(this, IconTextSubscriptLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextSubscriptLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextSubscript",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextSubscriptLine.displayName = "IconTextSubscriptLine";
  return IconTextSubscriptLine;
}(Component);

IconTextSubscriptLine.glyphName = 'text-subscript';
IconTextSubscriptLine.variant = 'Line';
IconTextSubscriptLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextSubscriptLine;
export { IconTextSubscriptLine };